/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SendAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function SendAction({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/MessageTools/Internal/Tools/SendAction"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let messageComposeSendFromIdValueData = fromData.useDataValue({ viewPath,
context: 'message_compose',
path: 'send_from_id',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(messageComposeSendFromIdValueData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}